import { ConfigProvider } from '@arco-design/web-react';
import { useContext } from 'react';
var defaultCopy = {
    ofTotal: '#{from}-#{to} of #{total}',
};
export var useI18nCopy = function () {
    var _a;
    var locale = useContext(ConfigProvider.ConfigContext).locale;
    var t = (locale === null || locale === void 0 ? void 0 : locale.Pagination) ||
        ((_a = locale === null || locale === void 0 ? void 0 : locale.M4B) === null || _a === void 0 ? void 0 : _a.Pagination) ||
        defaultCopy;
    return t;
};
